import React from 'react';
import Typical from 'react-typical';
import styled from '@emotion/styled';

// proyectos
const proyectos = [
    {id: 1, nombre: 'Product Hunt Clone', descripcion: "It is a clone of the product search website, users will be able to register, register products, receive votes and comments!, Making their brands and products known to everyone.", img: './img/product-hunt.png', site: 'https://product-hunt-54d75.firebaseapp.com/', repositore: 'https://github.com/ezelujan/product-hunt', tech: [
        {id: 1, nombre: 'React'},
        {id: 2, nombre: 'Next.js'},
        {id: 3, nombre: 'Firebase'}
    ]},
    {id: 2, nombre: 'PCsNET Task', descripcion: "A web application to have a better order when delegating tasks in the PCsNET company. It allows you to log in and start creating projects and assigning tasks, as well as creating accounts and seeing all the actions that any user has done in the application if you are an administrator. Users will be able to mark and unmark completed tasks and will have the utility of creating descriptions in the task if necessary.", img: './img/pcsnet-task.png', site: 'https://pcsnet.netlify.app/', repositore: '', tech: [
        {id: 1, nombre: 'React'},
        {id: 2, nombre: 'Node.js'},
        {id: 3, nombre: 'Express.js'},
        {id: 4, nombre: 'MongoDB'}
    ]},
    {id: 3, nombre: 'Redux App', descripcion: "It is a web application where you can create a product, giving it a name and a price, listing itself automatically and giving you options to edit or delete this same product.", img: './img/redux-app.png', site: 'https://eze-redux.netlify.app/', repositore: 'https://github.com/ezelujan/redux-crud', tech: [
        {id: 1, nombre: 'React'},
        {id: 2, nombre: 'Redux'},
        {id: 3, nombre: 'REST API(json-server)'}
    ]},
    {id: 4, nombre: 'Drink Recipes', descripcion: "A web page where you can enter some data, with which you will make a query and bring the recipe you want with its ingredients.", img: './img/recetas-bebidas.png', site: 'https://eze-bebidas.netlify.app/', repositore: 'https://github.com/ezelujan/recetas-bebidas', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'Context'},
        {id: 3, nombre: 'API'}
    ]},
    {id: 5, nombre: 'Cryptocurrency Quote', descripcion: 'You will be able to quote 10 types of cryptocurrencies in real time and get their price instantly, be it Bitcoin to USD or Ethereum to Colombian Peso, the data comes from an API.', img: './img/criptomonedas.png', site: 'https://eze-cripto.netlify.app/', repositore: 'https://github.com/ezelujan/criptomonedas', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'Styled Components'},
        {id: 3, nombre: 'API'}
    ]},
    {id: 6, nombre: 'Get Weather', descripcion: 'You can check the weather of a city, with just 3 clicks. The data will be sent to an API and it will return your weather.', img: './img/clima.png', site: 'https://eze-clima.netlify.app/', repositore: 'https://github.com/ezelujan/clima', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'API'}
    ]},
    {id: 7, nombre: 'Song Lyrics', descripcion: "This project queries two API's at the same time and allows displaying the information about the song and the artist you want to search for.", img: './img/letra-canciones.png', site: 'https://eze-cancion.netlify.app/', repositore: 'https://github.com/ezelujan/letra-cancion', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: "API's"}
    ]},
    {id: 8, nombre: 'Image Finder', descripcion: 'You can search for any type of image, at the highest quality, they come from the API of pixabay and this page has a custom pager.', img: './img/pixabay.png', site: 'https://eze-pixabay.netlify.app/', repositore: 'https://github.com/ezelujan/buscador-imagenes', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'API'}
    ]},
    {id: 9, nombre: 'Veterinary Appointments', descripcion: 'In this web application you can assign personalized appointments to your clients and you can manage all the appointments in your clinic.', img: './img/veterinaria.png', site: 'https://eze-veterinaria.netlify.app/', repositore: 'https://github.com/ezelujan/citas-veterinaria', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'Local Storage'}
    ]},
    {id: 10, nombre: 'Expense Management', descripcion: "It is an application where you can manage your expenses, alerting you when you have little money left. Hooks are used and show components conditionally.", img: './img/gasto-semanal.png', site: 'https://eze-gastos.netlify.app/', repositore: 'https://github.com/ezelujan/gestion-gastos', tech: [
        {id: 1, nombre: 'React Hooks'}
    ]},
    {id: 11, nombre: 'Insurance quote', descripcion: 'Depending on the plan you choose, the year and the brand of your car, it will quote you how much auto insurance is worth.', img: './img/cotizador-seguros.png', site: 'https://eze-cotizar.netlify.app/', repositore: 'https://github.com/ezelujan/cotizador-seguros', tech: [
        {id: 1, nombre: 'React Hooks'},
        {id: 2, nombre: 'Helpers'}
    ]}
]

// Palabras maquina de escribir
const palabra = <Typical
                    loop={Infinity}
                    wrapper="span"
                    steps={[
                        'athletic.', 1000,
                        'strategic.', 1000,
                        'autodidactic.', 1000,
                        'passionate.', 1000,
                        'flexible to change.', 1000,
                        'a curious developer', 2000
                    ]}
                />

// Styled Components
const sideleft = styled.div`
    width: 40px;
    position: fixed;
    bottom: 0px;
    left: 40px;
    right: auto;
    z-index: 10;
    color: var(--textColor1);
    ul {
        display: flex;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        padding: 0px;
        margin: 0px;
        list-style: none;
        ::after {
            content: "";
            display: block;
            width: 1px;
            height: 90px;
            background-color: var(--negro);
            margin: 0px auto;
        }
        li {
            display: list-item;
            text-align: -webkit-match-parent;
            &:last-of-type {
                margin-bottom: 20px;
            }
            a {
                display: inline-block;
                text-decoration-skip-ink: auto;
                color: inherit;
                position: relative;
                padding: 10px;
                cursor: pointer;
                text-decoration: none;
                transition: all 0.2s;
                font-size: 20px;
                :hover {
                    color: var(--textColor2);
                    transform: translateY(-5px);
                }
                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
    @media (max-width: 62.5em) {
        right: 25px;
    }
    @media (max-width: 48em) {
        display: none;
    }
`;
const sideright = styled.div`
    width: 40px;
    position: fixed;
    bottom: 0px;
    left: auto;
    right: 40px;
    z-index: 10;
    div {
        display: flex;
        flex-direction: column;
        -webkit-box-align: center;
        align-items: center;
        position: relative;
        ::after {
            content: "";
            display: block;
            width: 1px;
            height: 90px;
            background-color: var(--negro);
            margin: 0px auto;
        }
        a {
            cursor: pointer;
            text-decoration: none;
            position: relative;
            display: inline-block;
            margin: 20px auto;
            padding: 10px;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0.1em;
            font-family: var(--fontTitulo);
            color: var(--textColor1);
            transition: all 0.2s;
            writing-mode: vertical-rl;
            -webkit-writing-mode: vertical-rl;
            :hover {
                color: var(--textColor2);
                transform: translateY(-5px);
            }
        }
    }
    @media (max-width: 62.5em) {
        right: 25px;
    }
    @media (max-width: 48em) {
        display: none;
    }
`;

const encabezado = styled.header`
    width: inherit;
    margin: 20px 60px 0 60px;
    height: auto;
    @media(max-width: 30em) {
        margin: 20px 20px 0 20px;
    }
    nav {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        box-shadow: 0 1px 2px -2px var(--textColor1);
        @media(max-width: 30em){
            flex-direction: column;
            padding-bottom: 10px;
        }
        img {
            width: 40px;
            margin-bottom: 10px;
        }
        ul {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            counter-reset: item;
            @media(max-width: 30em) {
                margin-top: 10px;
            }
            li {
                list-style: none;
                display: flex;
                align-items: center;
                font-family: var(--fontTitulo);
                ::before {
                    counter-increment: item;
                    content: "0" counter(item) ".";
                    text-align: right;
                    color: var(--textColor2);
                    font-size: 12px;
                    margin-right: 5px;
                    @media(max-width: 30em) {
                        margin-right: 0;
                    }
                }
            }
            span {
                font-size: 14px;
                color: #000;
                cursor: pointer;
                font-weight: 400;
                transition: all 0.2s;
                border-bottom: 2px solid transparent;
                :hover {
                    border-bottom: 2px solid var(--textColor2);
                }
            }
        }
    }
`;

const contenedorpresentacion = styled.div`
    min-height: 95vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 90px 180px;
    @media (max-width: 62.5em) {
        padding: 90px 100px;
    }
    @media (max-width: 48em) {
        padding: 90px 50px;
    }
    @media (max-width: 37.5em) {
        padding: 50px 50px
    }
    @media (max-width: 30em) {
        padding: 50px 25px;
    }
`;
const texto = styled.div`
    text-align: left;
    margin-top: -70px;
    h1{
        color: var(--textColor2);
        font-size: 22px;
        font-weight: 300;
    }
    h2{
        color: var(--textColor2);
        font-size: 40px;
        font-weight: 700;
    }
    h3{
        color: var(--textColor3);
        font-size: 30px;
        font-weight: 600;
    }
    span {
        font-weight: 700;
    }
`;
const contenedorimg = styled.div`
    width: 300px;
    img {
        width: inherit;
    }
    @media (max-width: 62.5em) {
        width: 300px;
        height: auto;
    }
    @media (max-width: 48em) {
        width: 250px;
        height: auto;
    }
    @media (max-width: 37.5em) {
        display: none;
    }
`;
const sectionabout = styled.section`
    background-color: rgb(240, 240, 240);
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: justify;
    padding: 90px 180px;
    width: 100%;
    @media (max-width: 62.5em) {
        padding: 90px 100px;
    }
    @media (max-width: 48em) {
        padding: 90px 50px;
    }
    @media (max-width: 37.5em) {
        flex-direction: column;
    }
    @media (max-width: 30em) {
        padding: 50px 25px;
    }
`;
const abouttext = styled.div`
    margin-right: 150px;
    @media (max-width: 75em) {
        margin-right: 100px;
    }
    @media (max-width: 62.5em) {
        margin-right: 50px;
    }
    @media (max-width: 48em) {
        margin-right: 25px;
    }
    @media (max-width: 37.5em) {
        margin-right: 0;
    }
    h3 {
        padding-bottom: 50px;
        color: var(--textColor2);
        font-size: 27px;
        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", "Lucida Console", Monaco, monospace;
        ::before {
            font-family: var(--fontTitulo);
            counter-increment: section;
            content: "0" counter(section) ".";
            color: var(--textColor3);
            font-weight: 500;
            font-size: 21px;
            margin-right: 8px;
        }
        ::after {
            content: "";
            display: block;
            width: 100%;
            height: 1px;
            background-color: rgb(200, 200, 200);
        }
    }
    p {
        margin-bottom: 30px;
        font-size: 17px;
    }
    ul {
        width: 350px;
        display: flex;
        justify-content: space-between;
        list-style: none;
        @media (max-width: 30em) {
            width: auto;
            flex-direction: column;
        }
        li{
            margin-bottom: 5px;
            font-family: 'Fira Mono', monospace;
            font-size: 15px;
            color: var(--textColor1);
            letter-spacing: 0.05em;
            ::before {
                display: inline-block;
                font-style: normal;
                font-variant: normal;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
                font-family: 'Font Awesome 5 Free';
                font-weight: 900;
                content: "\f0da";
                margin-right: 18px;
                color: var(--textColor2);
            }
        }
    }
    `;
const aboutimg = styled.div`
    img {
        width: 300px;
        border-radius: 5px;
        @media (max-width: 75em) {
            width: 250px;
        }
        @media (max-width: 62.5em) {
            width: 200px;
        }
        @media (max-width: 48em) {
            width: 170px;
        }
        @media (max-width: 37.5em) {
            margin-top: 50px;
            width: 200px;
        }
    }
`;

const sectionworks = styled.section`
    padding: 90px 180px;
    h3 {
        padding-bottom: 50px;
        color: var(--textColor2);
        font-size: 27px;
        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", "Lucida Console", Monaco, monospace;
        ::before {
            font-family: var(--fontTitulo);
            counter-increment: section;
            content: "0" counter(section) ".";
            color: var(--textColor3);
            font-weight: 500;
            font-size: 21px;
            margin-right: 8px;
        }
        ::after {
            content: "";
            display: block;
            width: 60%;
            height: 1px;
            background-color: rgb(200, 200, 200);
            @media (max-width: 37.5em) {
                width: 100%;
            }
        }
    }
    @media (max-width: 62.5em) {
        padding: 90px 100px;
    }
    @media (max-width: 48em) {
        padding: 90px 50px;
    }
    @media (max-width: 30em) {
        padding: 50px 25px;
    }
`;
const project = styled.div`
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(12, 1fr);
    align-items: center;
    margin-bottom: 100px;
    &:last-of-type {
        margin-bottom: 0;
    }
    &:nth-of-type(2n+1) {
        .data {
            grid-column: 7 / -1;
            text-align: right;
            @media (max-width: 37.5em) {
                grid-column: 1 / -1;
                padding: 40px 40px 30px;
            }
            @media (max-width: 30em) {
                padding: 30px 25px 20px;
            }
            .enlaces {
                justify-content: flex-end;
                margin-left: 0;
                margin-right: -10px;
            }
        }
        ul:nth-of-type(2n+1){
            justify-content: flex-end;
            li {
                margin-left: 20px;
                margin-right: 0px;
            }
        }
        .project-img {
            grid-column: 1 / 8;
            @media (max-width: 48em) {
                height: 100%;
            }
            @media (max-width: 37.5em) {
                grid-column: 1 / -1;
                opacity: 0.25;
            }
        }
    }
`;
const projectdata = styled.div`
    position: relative;
    grid-column: 1 / 7;
    grid-row: 1 / -1;
    transition: all 0.2s;
    z-index: 5;    
    h4 {
        font-size: 13px;
        font-weight: normal;
        color: var(--textColor3);
        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", "Lucida Console", Monaco, monospace;
        margin-top: 10px;
        padding-top: 0px;
    }
    h5 {
        font-size: 28px;
        color: var(--textColor2);
        margin: 0 0 20px;
        &:hover {
            color: var(--textColor3);
        }
        a {
            display: inline-block;
            text-decoration-skip-ink: auto;
            color: inherit;
            position: relative;
            cursor: pointer;
            text-decoration: none;
            transition: all 0.2s;
            @media (max-width: 48em) {
                display: block;
            }
        }
        @media (max-width: 48em) {
            font-size: 24px;
        }
    }
    @media (max-width: 37.5em) {
        grid-column: 1 / -1;
        padding: 40px 40px 30px;
    }
    @media (max-width: 30em) {
        padding: 30px 25px 20px;
    }
`;
const containerp = styled.div`
    box-shadow: rgba(2, 12, 27, 0.7) 0px 10px 30px -15px;
    position: relative;
    z-index: 2;
    padding: 25px;
    background-color: rgb(23, 42, 69);
    color: rgb(168, 178, 209);
    font-size: 16px;
    transition: all 0.2s;
    border-radius: 3px;
    @media (max-width: 37.5em) {
        background-color: transparent;
        padding: 20px 0;
        box-shadow: none;
        color: var(--textColor1);
        &:hover{
            box-shadow: none;
        }
    }
    p {
        margin: 0;
    }
`;
const containerul = styled.ul`
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    margin: 25px 0 10px;
    list-style: none;
    li {
        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", "Lucida Console", Monaco, monospace;
        font-size: 13px;
        color: rgb(136, 146, 176);
        margin-right: 20px;
        margin-bottom: 7px;
        white-space: nowrap;
        &:last-of-type {
            margin-right: 0;
        }
        @media (max-width: 37.5em) {
            margin-right: 10px
        }
    }
`;
const containerenlaces = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    position: relative;
    margin-top: 10px;
    margin-left: -10px;
    color: rgb(204, 214, 246);
    a {
        height: 22px;
        padding: 10px;
        cursor: default;
        svg {
            width: 22px;
            height: auto;
            color: var(--negro);
            transition: all 0.2s;
            cursor: pointer;
            &:hover {
                color: var(--textColor3);
            }
        }
    }
`;
const projectimg = styled.a`
    grid-column: 6 / -1;
    grid-row: 1 / -1;
    position: relative;
    z-index: 1;
    /* background-color: var(--textColor2); */
    border-radius: 4px;
    transition: all 0.2s;
    text-decoration: none;
    cursor: pointer;
    @media (max-width: 48em) {
        background: transparent;
        height: 100%;
    }
    @media (max-width: 37.5em) {
        grid-column: 1 / -1;
        opacity: 0.35;
    }
    &:hover,
    &:focus {
        background: transparent;
        &:before,
        img {
            background: transparent;
            filter: none;
        }
    }
    &:before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        transition: all 0.25s;
        background-color: var(--backgroungImg);
        mix-blend-mode: screen;
    }
    img {
        width: 100%;
        max-width: 100%;
        vertical-align: middle;
        border-radius: 3px;
        position: relative;
        mix-blend-mode: multiply;
        filter: grayscale(100%) contrast(1) brightness(90%);
        @media (max-width: 48em) {
            object-fit: cover;
            height: 100%;
            filter: grayscale(100%) contrast(1) brightness(80%);
        }
    }
`;
const footer = styled.footer`
    padding: 50px 180px;
    background-color: rgb(240, 240, 240);
    color: rgb(140, 140, 140);
    span {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        width: auto;
        margin: 0;
        i {
            cursor: pointer;
            transition: all 0.2s;
            &:hover {
                transform: translateY(-2px);
                color: var(--textColor2);
            }
        }
    }
    div {
        &:first-of-type {
            display: none;
            @media(max-width: 48em) {
                display: block;
            }
            ul {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: row;
                list-style: none;
                li{
                    padding: 10px;
                    font-size: 20px;
                }
            }
        }
        &:last-of-type {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            &:before {
                display: block;
                content: "";
                width: 50%;
                height: 1px;
                background-color: rgb(180, 180, 180);
                @media(max-width: 48em) {
                    width: 100%;
                }
            }
            p {
                padding: 10px;
            }
        }
    }
    a{
        text-decoration: none;
        color: inherit;
        transition: all 0.2s;
        &:hover {
            color: var(--textColor2);
        }
    }
    @media (max-width: 62.5em) {
        padding: 50px 100px;
    }
    @media (max-width: 48em) {
        padding: 30px 50px;
    }
    @media (max-width: 30em) {
        padding: 30px 25px;
    }
`;
const contact = styled.div`
    padding: 90px 180px;
    h3 {
        text-align: center;
        padding-bottom: 50px;
        color: var(--textColor2);
        font-size: 27px;
        font-family: "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", "Lucida Console", Monaco, monospace;
        ::before {
            font-family: var(--fontTitulo);
            counter-increment: section;
            content: "0" counter(section) ".";
            color: var(--textColor3);
            font-weight: 500;
            font-size: 21px;
            margin-right: 8px;
        }
        ::after {
            content: "";
            display: block;
            width: 100%;
            height: 1px;
            background-color: rgb(200, 200, 200);
            @media (max-width: 37.5em) {
                width: 100%;
            }
        }
    }
    div{
        display: flex;
        justify-content: center;
        align-items: center;
        :first-of-type {
            p {
                text-align: center;
                width: 70%;
                @media(max-width: 48em){
                    width: 100%;
                }
            }
        }
        :last-of-type {
            margin: 50px 0;
            a {
                display: flex;
                justify-content: center;
                align-items: center;
                text-decoration: none;
                color: var(--textColor2);
                width: 120px;
                height: 25px;
                padding: 20px;
                border: 2px solid var(--textColor2);
                border-radius: 3px;
                background-color: #4688ab25;
                transition: all .2s;
                &:hover {
                    background-color: #4688AB;
                    color: #fff;
                }
            }
        }
    }
    @media (max-width: 62.5em) {
        padding: 90px 100px;
    }
    @media (max-width: 48em) {
        padding: 90px 50px;
    }
    @media (max-width: 30em) {
        padding: 50px 25px;
    }
`;

export const Proyectos = proyectos;
export const Palabra = palabra;
export const SideLeft = sideleft;
export const SideRight = sideright;
export const Encabezado = encabezado;
export const ContenedorPresentacion = contenedorpresentacion;
export const Texto = texto;
export const ContenedorImg = contenedorimg;
export const SectionAbout = sectionabout;
export const AboutText = abouttext;
export const AboutImg = aboutimg;
export const SectionWorks = sectionworks;
export const Project = project;
export const ProjectData = projectdata;
export const ContainerP = containerp;
export const ContainerUl = containerul;
export const ContainerEnlaces = containerenlaces;
export const ProjectImg = projectimg;
export const Credits = footer;
export const ContainerContact = contact;